type TAutopricerExitGuard = (proceed: () => void) => void;

export const LISTING_SELECTION_AREA_SELECTOR = "[data-listing-selection-area]";

let autopricerExitGuard: TAutopricerExitGuard | null = null;

export const registerAutopricerExitGuard = (guard: TAutopricerExitGuard | null) => {
	autopricerExitGuard = guard;
};

export const requestAutopricerExit = (proceed: () => void) => {
	if (autopricerExitGuard) autopricerExitGuard(proceed);
	else proceed();
};
